import script from "./ConsoleWorkspaceCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsoleWorkspaceCreate.vue?vue&type=script&setup=true&lang=js"

import "./ConsoleWorkspaceCreate.vue?vue&type=style&index=0&id=abda5a66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abda5a66"]])

export default __exports__